import { faMobileAlt, faSave, faUndo, faUniversity } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react'
import NumberFormat from 'react-number-format';
import { Button, Col, Fade, FormGroup, Input, InputGroup, InputGroupAddon, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from 'reactstrap'
import { create, update } from '../../../../helpers/api/banks';
import { SUCCESS_RESPONSE } from '../../../../helpers/codeResponses/codes';
import handleErrorMessage from '../../../../helpers/errors/handleErrorMessage';
import WizardError from '../../../auth/register/WizardError';
import ButtonIcon from '../../../common/ButtonIcon';
import Flex from '../../../common/Flex';
import { Toast } from '../../../UI/toast/Toast';

const PayMethodAddModal = ({ isOpen, setIsOpen, method: met, setSelected, mutate = () => { } }) => {

    const toggle = () => {
        setIsOpen(!isOpen);
        setSelected(null);
    };

    const [submitting, setSubmitting] = useState(false);

    const [method, setMethod] = useState(null);
    // eslint-disable-next-line
    const [bankInfo, setBankInfo] = useState({
        bank_name: '',
        owner_name: '',
        account_number: null,
        prefix: 'V',
        dni: '',
    })
    // eslint-disable-next-line
    const [mobileInfo, setMobileInfo] = useState({
        bank_name: '',
        owner_name: '',
        phoneNumber: null,
        prefix: 'V',
        dni: '',
    })
    // eslint-disable-next-line
    const [zelleInfo, setZelleInfo] = useState({
        email: '',
        owner_name: '',
        zelle_bank: '',
    })
    const [errors, setErrors] = useState(null);

    useEffect(() => {
        if (met) {
            setMethod(met.method);
            if(met?.method === 'bank'){
                setBankInfo({
                    bank_name: met.name,
                    owner_name: met.owner_name,
                    dni: met.owner_dni,
                    account_number: met.account_number,
                    prefix: met.owner_dni.substring(0, 1),
                 })
            }
        }
    }, [met])

    const handleBankInfoChange = e => {
        e.preventDefault();
        const { name, value } = e.target;

        switch (name) {
            case 'bank_name':
                setBankInfo(prev => ({ ...prev, bank_name: value }));
                setErrors((prev) => ({
                    ...prev,
                    bank_name: value.length < 5 ? 'El nombre del banco debe tener al menos 5 carácteres.' : null
                }))
                break;
            case 'owner_name':
                setBankInfo(prev => ({ ...prev, owner_name: value }));
                setErrors((prev) => ({
                    ...prev,
                    owner_name: !/^[ a-zA-Z\u00C0-\u017F]+$/.test(value) ? 'Ingrese un nombre válido.' : value.length < 4 ? 'El nombre del titular debe tener al menos 4 carácteres.' : null
                }))
                break;
            case 'account_number':
                let acc = value.replace(/ /g, '');
                setBankInfo(prev => ({ ...prev, account_number: acc }));
                setErrors((prev) => ({
                    ...prev,
                    account_number: acc.length < 16 ? 'El numero de cuenta debe tener al menos 16 carácteres.' : null
                }))
                break;
            case 'dni':
                let d = value.replace(/,/g, '');
                setBankInfo(prev => ({ ...prev, dni: d }));
                setErrors((prev) => ({
                    ...prev,
                    dni: !/^[-,.0-9]+$/.test(value) ? 'Número de cédula inválido' : d.length < 7 ? 'El numero de cédula debe tener al menos 7 carácteres.' : null
                }))
                break;
            default:
                break;
        }
    }

    const handleMobileInfoChange = e => {
        e.preventDefault();
        const { name, value } = e.target;

        switch (name) {
            case 'bank_name':
                setMobileInfo(prev => ({ ...prev, bank_name: value }));
                setErrors((prev) => ({
                    ...prev,
                    bank_name: value.length < 5 ? 'El nombre del banco debe tener al menos 5 carácteres.' : null
                }))
                break;
            case 'owner_name':
                setMobileInfo(prev => ({ ...prev, owner_name: value }));
                setErrors((prev) => ({
                    ...prev,
                    owner_name: !/^[a-zA-Z\u00C0-\u017F]+$/.test(value) ? 'Ingrese un nombre válido.' : value.length < 4 ? 'El nombre del titular debe tener al menos 4 carácteres.' : null
                }))
                break;
            case 'dni':
                let d = value.replace(/,/g, '');
                setMobileInfo(prev => ({ ...prev, dni: d }));
                setErrors((prev) => ({
                    ...prev,
                    dni: !/^[-,.0-9]+$/.test(value) ? 'Número de cédula inválido' : d.length < 7 ? 'El numero de cédula debe tener al menos 7 carácteres.' : null
                }))
                break;
            default:
                break;
        }
    }

    const handleZelleInfoChange = e => {
        e.preventDefault();
        const { name, value } = e.target;

        switch (name) {
            case 'zelle_bank':
                setZelleInfo(prev => ({ ...prev, zelle_bank: value }));
                setErrors((prev) => ({
                    ...prev,
                    zelle_bank: value.length < 5 ? 'El nombre del banco debe tener al menos 5 carácteres.' : null
                }))
                break;
            case 'owner_name':
                setZelleInfo(prev => ({ ...prev, owner_name: value }));
                setErrors((prev) => ({
                    ...prev,
                    owner_name: !/^[a-zA-Z\u00C0-\u017F]+$/.test(value) ? 'Ingrese un nombre válido.' : value.length < 4 ? 'El nombre del titular debe tener al menos 4 carácteres.' : null
                }))
                break;
            case 'email':
                setZelleInfo(prev => ({ ...prev, email: value }));
                setErrors((prev) => ({
                    ...prev,
                    email: !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) ? 'Correo electrónico inválido' : null
                }))
                break;
            default:
                break;
        }
    }

    const handlePhoneNumberChange = ({ value }) => {
        setMobileInfo(prev => ({ ...prev, phoneNumber: value }));
        setErrors((prev) => ({
            ...prev,
            phoneNumber: value.length < 7 ? 'El numero de cuenta debe tener al menos 7 carácteres.' : null
        }))
    }

    const closeBtn = <>
        <Button className="close font-weight-normal bg-transparent border-0 shadow-none" onClick={toggle}>
            &times;
        </Button>
    </>

    const save = (e) => {
        e.preventDefault();
        if (method === 'bank') {
            if (errors.bank_name || errors.owner_name || errors.account_number || errors.dni) {
                return;
            }
            setSubmitting(true);
            if (!!!met) {
                create({ ...bankInfo, name: bankInfo.bank_name, owner_dni: `${bankInfo.prefix}${bankInfo.dni}` })
                    .then(({ code }) => {
                        if (code === SUCCESS_RESPONSE.CREATED) {
                            setBankInfo({ bank_name: '', owner_name: '', account_number: '', dni: '' })
                            setErrors({ bank_name: null, owner_name: null, account_number: null, dni: null })
                            mutate();
                            setIsOpen(false);
                            Toast.fire({
                                title: 'Se ha guardado la información de su cuenta bancaria.',
                                type: 'success'
                            })
                        }
                    })
                    .catch(err => handleErrorMessage(err))
                    .finally(() => setSubmitting(false))
            } else {
                update(met?.bank_id, { ...bankInfo, name: bankInfo.bank_name, owner_dni: `${bankInfo.prefix}${bankInfo.dni}` })
                    .then(({ code }) => {
                        if (code === SUCCESS_RESPONSE.OK) {
                            setBankInfo({ bank_name: '', owner_name: '', account_number: '', dni: '' })
                            setErrors({ bank_name: null, owner_name: null, account_number: null, dni: null })
                            mutate();
                            setIsOpen(false);
                            Toast.fire({
                                title: 'Se ha actualizado la información de su cuenta bancaria.',
                                type: 'success'
                            })
                        }
                    })
                    .catch(err => handleErrorMessage(err))
                    .finally(() => setSubmitting(false))
            }
        }
    }

    return <>
        <Modal isOpen={isOpen} toggle={toggle} centered modalClassName="theme-modal"  >
            <form onSubmit={(e) => save()}>
                <ModalHeader toggle={toggle} tag="div" className="px-card bg-light border-0 flex-between-center" close={closeBtn}>
                    <h5 className='mb-0'>{met ? met?.method === 'bank' ? 'Edición de método de pago - Banco' : met?.method === 'mobile' ? 'Edición de método de pago - Pago Móvil' : met?.method === 'zelle' ? 'Edición de método de pago - Zelle' : 'Edición de método de pago' : method === 'bank' ? 'Registro de método de pago - Banco' : method === 'mobile' ? 'Registro de método de pago - Pago Móvil' : method === 'zelle' ? 'Registro de método de pago - Zelle' : 'Registro de método de pago'}</h5>
                </ModalHeader>
                <ModalBody className="px-card pb-card pt-card fs--1">
                    {!!!method && <Flex className='w-100' column>
                        <span className='mb-3 fs--1'>Seleccione un método de pago</span>
                        <ButtonIcon color='falcon-default' onClick={() => setMethod('bank')} icon={faUniversity} className='mb-3 py-4'>Banco</ButtonIcon>
                        <ButtonIcon color='falcon-default' disabled onClick={() => {/* setMethod('mobile') */ Toast.fire({ type: 'error', title: 'Método deshabilitado temporalmente.' }) }} icon={faMobileAlt} className='mb-3 py-4'>Pago móvil</ButtonIcon>
                        <Button color='falcon-default' disabled onClick={() => {/* setMethod('zelle') */ Toast.fire({ type: 'error', title: 'Método deshabilitado temporalmente.' }) }} className='py-4'>Zelle</Button>
                    </Flex>}

                    {!!method && !met && <Fade in={!!method}>
                        <Flex align='center' className='mb-3' justify='start'>
                            <ButtonIcon icon={faUndo} onClick={() => {
                                setMethod(null);
                                setErrors(null);
                                setBankInfo({ bank_name: '', account_number: '', owner_name: '', prefix: 'V', dni: '' });
                                setMobileInfo({ bank_name: '', phoneNumber: '', owner_name: '', prefix: 'V', dni: '' });
                                setZelleInfo({ zelle_bank: '', owner_name: '', email: '' });
                            }} color='falcon-default' size='sm' >Anterior</ButtonIcon>
                        </Flex>
                    </Fade>}

                    {method === 'bank' && <Fade in={method === 'bank'}>
                        <Row>
                            <Col>
                                <Row form>
                                    <Col tag={FormGroup}>
                                        <Label>Nombre del banco</Label>
                                        <Input type='text' name='bank_name' defaultValue={!!method && !!met && met?.method === 'bank' ? met?.name : ''} onChange={handleBankInfoChange} className={classNames({ 'border-danger': errors?.bank_name })} />
                                        <WizardError className='mt-2' error={errors?.bank_name} />
                                    </Col>
                                </Row>
                                <Row form>
                                    <Col tag={FormGroup}>
                                        <Label>Titular de la cuenta</Label>
                                        <Input type='text' onChange={handleBankInfoChange} defaultValue={!!method && !!met && met?.method === 'bank' ? met?.owner_name : ''} name='owner_name' />
                                        <WizardError className='mt-2' error={errors?.owner_name} />
                                    </Col>
                                </Row>
                                <Row form>
                                    <Col tag={FormGroup}>
                                        <Label>Número de cuenta</Label>
                                        <NumberFormat format='#### #### #### #### ####' name='account_number' defaultValue={!!method && !!met && met?.method === 'bank' ? met?.account_number : null} onChange={handleBankInfoChange} className={classNames('form-control', { 'border-danger': errors?.account_number })} />
                                        <WizardError className='mt-2' error={errors?.account_number} />
                                    </Col>
                                </Row>
                                <Row form>
                                    <Col tag={FormGroup}>
                                        <Label>DNI (Cédula de identidad o RIF)</Label>
                                        <InputGroup>
                                            <InputGroupAddon addonType="prepend">
                                                <Input type='select' defaultValue={!!method && !!met && met?.method === 'bank' ? met?.owner_dni?.charAt(0) : null} onChange={(e) => {
                                                    setBankInfo(prev => ({ ...prev, prefix: e.target.value }));
                                                }}>
                                                    <option value="V">V</option>
                                                    <option value="E">E</option>
                                                    <option value="J">J</option>
                                                </Input>
                                            </InputGroupAddon>
                                            <NumberFormat
                                                className={classNames("form-control", { 'border-danger': errors?.dni })}
                                                name='dni'
                                                defaultValue={!!method && !!met && met?.method === 'bank' ? parseFloat(met?.owner_dni?.substring(1, 40)) : null}
                                                onChange={handleBankInfoChange}
                                                decimalSeparator={false}
                                                thousandSeparator={true}
                                            />
                                        </InputGroup>
                                        <WizardError className='mt-2' error={errors?.dni} />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Fade>}

                    {method === 'mobile' && <Fade in={method === 'mobile'}>
                        <Row>
                            <Col>
                                <Row form>
                                    <Col tag={FormGroup}>
                                        <Label>Banco</Label>
                                        <Input type='text' name='bank_name' defaultValue={!!method && !!met && met?.method === 'mobile' ? met?.bank_name : ''} onChange={handleMobileInfoChange} className={classNames({ 'border-danger': errors?.bank_name })} />
                                        <WizardError error={errors?.bank_name} />
                                    </Col>
                                </Row>
                                <Row form>
                                    <Col tag={FormGroup}>
                                        <Label>Titular de la cuenta</Label>
                                        <Input type='text' name='owner_name' defaultValue={!!method && !!met && met?.method === 'mobile' ? met?.owner_name : ''} onChange={handleMobileInfoChange} className={classNames({ 'border-danger': errors?.owner_name })} />
                                        <WizardError error={errors?.owner_name} />
                                    </Col>
                                </Row>
                                <Row form>
                                    <Col tag={FormGroup}>
                                        <Label>Número de teléfono</Label>
                                        <NumberFormat format='+58 (###) ### ####' defaultValue={!!method && !!met && met?.method === 'mobile' ? parseFloat(met?.phoneNumber) : ''} name='phoneNumber' onValueChange={handlePhoneNumberChange} className={classNames('form-control', { 'border-danger': errors?.phoneNumber })} />
                                        <WizardError error={errors?.phoneNumber} />
                                    </Col>
                                </Row>
                                <Row form>
                                    <Col tag={FormGroup}>
                                        <Label>DNI (Cédula de identidad o RIF)</Label>
                                        <InputGroup>
                                            <InputGroupAddon addonType="prepend">
                                                <Input type='select' defaultValue={!!method && !!met && met?.method === 'mobile' ? met?.dni?.charAt(0) : null} onChange={(e) => {
                                                    setMobileInfo(prev => ({ ...prev, prefix: e.target.value }))
                                                }}>
                                                    <option value="V">V</option>
                                                    <option value="E">E</option>
                                                    <option value="J">J</option>
                                                </Input>
                                            </InputGroupAddon>
                                            <NumberFormat
                                                allowedDecimalSeparators={false}
                                                className={classNames("form-control", { 'border-danger': errors?.dni })}
                                                defaultValue={!!method && !!met && met?.method === 'mobile' ? parseFloat(met?.dni?.substring(1, 40)) : null}
                                                onChange={handleMobileInfoChange} thousandSeparator={true}
                                                renderText={(value, props) => <div {...props}>{value}</div>}
                                            />
                                        </InputGroup>
                                        <WizardError error={errors?.dni} />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Fade>
                    }
                    {method === 'zelle' && <Fade in={method === 'zelle'}>
                        <Row>
                            <Col>
                                <Row form>
                                    <Col tag={FormGroup}>
                                        <Label>Correo electrónico asociado a Zelle</Label>
                                        <Input type='email' name='email' defaultValue={!!method && !!met && met?.method === 'zelle' ? met?.email : ''} onChange={handleZelleInfoChange} className={classNames({ 'border-danger': errors?.email })} />
                                        <WizardError error={errors?.email} />
                                    </Col>
                                </Row>
                                <Row form>
                                    <Col tag={FormGroup}>
                                        <Label>Titular de la cuenta</Label>
                                        <Input type='text' name="owner_name" defaultValue={!!method && !!met && met?.method === 'zelle' ? met?.owner_name : ''} onChange={handleZelleInfoChange} className={classNames({ 'border-danger': errors?.owner_name })} />
                                        <WizardError error={errors?.owner_name} />
                                    </Col>
                                </Row>
                                <Row form>
                                    <Col tag={FormGroup}>
                                        <Label>Banco asociado a Zelle</Label>
                                        <Input type='text' name='zelle_bank' defaultValue={!!method && !!met && met?.method === 'zelle' ? met?.bank_name : ''} onChange={handleZelleInfoChange} className={classNames({ 'border-danger': errors?.zelle_bank })} />
                                        <WizardError error={errors?.zelle_bank} />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Fade>
                    }
                </ModalBody>
                <ModalFooter tag={Flex} justify="end" className="bg-light px-card border-top-0">
                    <ButtonIcon icon={faUndo} onClick={() => {
                        toggle();
                        setMethod(null);
                        setErrors(null);
                        setBankInfo({ bank_name: '', account_number: '', owner_name: '', prefix: 'V', dni: '' });
                        setMobileInfo({ bank_name: '', phoneNumber: '', owner_name: '', prefix: 'V', dni: '' });
                        setZelleInfo({ zelle_bank: '', owner_name: '', email: '' });

                    }} className='mr-3 px-5' color="falcon-default" size="md" transform="down-1 shrink-4" >
                        <span>Volver</span>
                    </ButtonIcon>
                    <ButtonIcon icon={faSave} onClick={save} type='submit' className='px-5' color="primary" size="md" transform="down-1 shrink-4" data-testid="submit-button">
                        {!!met ? <span>Registrar</span> : <span>Guardar</span>}
                        {submitting && <Spinner size="sm" className='mr-2' />}
                    </ButtonIcon>
                </ModalFooter>
            </form>
        </Modal>
    </>
}

export default PayMethodAddModal;